import { render, staticRenderFns } from "./wakeAddEdit.vue?vue&type=template&id=34854a56"
import script from "./wakeAddEdit.vue?vue&type=script&lang=js"
export * from "./wakeAddEdit.vue?vue&type=script&lang=js"
import style0 from "./wakeAddEdit.vue?vue&type=style&index=0&id=34854a56&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports